/**
 * Date Range Picker Orchestrator
 * Loads modules and exports LiteDateRangePicker class
 * @module date-range-litepicker
 */
(function(window){
  'use strict';

  class LiteDateRangePicker extends window.LiteDateRangePickerCore {
    constructor(opts){
      super(opts);
    }
  }

  window.LiteDateRangePicker = LiteDateRangePicker;
})(window);
